import { Layout } from 'components/missed-deal-feedback/components/layout';
import { Amount } from 'components/shared/Amount/Amount';
import { FormattedMessage } from 'components/shared/Intl';
import { useAppSelector } from 'hooks/useAppSelector';
import { FormIdProps } from 'shared/props';
import { getUserFeedbackPriceEnhancement } from 'state/missed-deal-feeedback/selectors';

const precision = 4;

export function PriceEnhancedReadonly({ formId }: FormIdProps) {
  const { xMargin, tradingOffer } = useAppSelector(s => getUserFeedbackPriceEnhancement(s, formId)!);

  return (
    <>
      <div className="text-wrap font-italic">
        <FormattedMessage id="missedDealFeedback.priceEnhanced" />
      </div>
      <Layout.Row data-e2e="price-adjustment">
        <div className="col-12 col-sm-4 form-group">
          <label htmlFor="xMargin">
            <FormattedMessage id="form.XMargin" />
          </label>
          <Amount
            id="xMargin"
            accelerators={[]}
            precision={precision}
            decimalPadding={false}
            isDisabled={false}
            isReadOnly
            value={xMargin}
            hasError={false}
          />
        </div>
        <div className="col-12 col-sm-4 form-group">
          <label htmlFor="tradingOffer">
            <FormattedMessage id="form.TradingOffer" />
          </label>
          <Amount
            id="tradingOffer"
            accelerators={[]}
            precision={precision}
            decimalPadding={false}
            isDisabled={false}
            isReadOnly
            value={tradingOffer}
            hasError={false}
          />
        </div>
      </Layout.Row>
    </>
  );
}
